import useApi from "../../index";

const useSettingsActions = () => {
  const { useServices } = useApi();
  const { useSettingsServices } = useServices();
  const {
    listSettingsService,
    getSettingService,
    createSettingService,
    updateSettingService,
    deleteSettingService
  } = useSettingsServices();

  const actListSettings = async ({ page, page_size, search }, onSuccess, onError) => {
    try {
      const response = await listSettingsService({ page, page_size, search });
      onSuccess && onSuccess(response.data);
    } catch (error) {
      onError && onError(error);
    }
  };

  const actGetSetting = async (id, onSuccess, onError) => {
    try {
      const response = await getSettingService(id);
      onSuccess && onSuccess(response.data);
    } catch (error) {
      onError && onError(error);
    }
  };

  const actCreateSetting = async (data, onSuccess, onError) => {
    try {
      const response = await createSettingService(data);
      onSuccess && onSuccess(response.data);
    } catch (error) {
      onError && onError(error);
    }
  };

  const actUpdateSetting = async (id, data, onSuccess, onError) => {
    try {
      const response = await updateSettingService(id, data);
      onSuccess && onSuccess(response.data);
    } catch (error) {
      onError && onError(error);
    }
  };

  const actDeleteSetting = async (id, onSuccess, onError) => {
    try {
      const response = await deleteSettingService(id);
      onSuccess && onSuccess(response);
    } catch (error) {
      onError && onError(error);
    }
  };

  return {
    actListSettings,
    actGetSetting,
    actCreateSetting,
    actUpdateSetting,
    actDeleteSetting,
  };
};

export default useSettingsActions;
